import { CALL_API } from 'redux-api-middleware'
import { get, post } from 'utils/network'

export const fetchCurrentSemester = () => {
  const request = get('/semesters/current')
  request.types = ['_REQ', '_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const setDefaultSemester = () => {
  const request = post('/semesters/set-default')
  request.types = ['_REQ', '_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const setActive = (value) => {
  const request = post('/semesters/set-active', { value })
  request.types = ['_REQ', '_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const setOpen = (value) => {
  const request = post('/semesters/set-open', { value })
  request.types = ['_REQ', '_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Semester/actions.js